import { defineStore } from 'pinia'
import axios from 'axios'

export const useLanguagesStore = defineStore('languages', {
  state: () => ({
    languages: [],
    loaded: false,
  }),

  getters: {
    /**
     * { code: label } - labels en français
     */
    labelsByCode: (state) => {
      const map = {}
      state.languages.forEach((lang) => {
        map[lang.code] = lang.label
      })
      return map
    },

    /**
     * { code: labelEnglish } - labels en anglais
     */
    labelsByCodeEnglish: (state) => {
      const map = {}
      state.languages.forEach((lang) => {
        map[lang.code] = lang.labelEnglish
      })
      return map
    },
  },

  actions: {
    async loadLanguages() {
      if (this.loaded) return
      try {
        const { data } = await axios.get('/api/languages')
        this.languages = data
      } catch (error) {
        console.error('Failed to load languages', error)
      }
      this.loaded = true
    },
  },
})
